export default __webpack_public_path__ + "static/Figtree-Bold-8cfa00d66faf3676098d77f8de4947c0.woff";